import {memo} from "react";
import BaseFrame from "./Breadcrumb";
import {ThreeDots} from "@dvrt/graphql-widgets";

export default memo(() => {
    return (
        <BaseFrame>
            <ThreeDots height={5} />
        </BaseFrame>
    );
});
